import { ResendEmailRequest } from './../../models/ss-api/requests/resend.email.request';

import { ChangeDetectorRef, Component, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { Title, SafeHtml } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';

import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../services/ss-api.service';
import { Router } from '@angular/router';

export interface IEmailPreviewDialogModel {
  MemberID?: number;
  emailID?: number;
  emailContent: string;
  emailSubject: string;
}

@Component({
  selector: 'email-preview-dialog',
  templateUrl: './email.preview.dialog.html',
  styleUrls: ['./email.preview.dialog.css'],

})

export class EmailPreviewDialog extends DialogComponent<IEmailPreviewDialogModel, boolean> implements IEmailPreviewDialogModel, AfterViewInit, OnInit, OnDestroy {

  IsBusy: Boolean = true;

  MemberID: number;
  emailID: number;
  emailContent: string;
  emailSubject: string;



  ngAfterViewInit(): void {
    // throw new Error("Method not implemented.");
  }

  constructor(dialogService: DialogService, private titleService: Title, private changeDetect: ChangeDetectorRef, private sweetAlertService: SweetAlertService, private sanitizer: DomSanitizer, private api: ssApiService, public router: Router ) {
    super(dialogService, router);
  }

  ngOnInit() {
    // this.MemberID = this.ticketManager.Ticket().MemberID;
    this.IsBusy = false;
  }

  ngOnDestroy() {

  }

  async confirm() {
    this.closeOK();
  }

  ResendEmail() {
    //no more member id - just email id
    let request: ResendEmailRequest = {
      EmailID: this.emailID
    }

    this.sweetAlertService.swal({
      type: 'warning',
      title: 'Are you sure?',
      text: 'This action cannot be undone',
      showConfirmButton: true,
      showCancelButton: true
    }).then((confirm) => {
      let disposable = this.api.ResendEmail(request).subscribe(response => {
        if (response.Result) {
          this.sweetAlertService.swal({
            type: 'success',
            title: 'Email Resent',
            timer: 1500
          }).then( () => {}, () => {} )
        } else {
          this.sweetAlertService.swal({
            type: 'errpr',
            title: 'Error',
            text: response.Message
          }).then( () => {}, () => {} )

        }
        disposable.unsubscribe();
      })
    }, (dismiss) => {
    })
  }

  closeOK() {
    // we set dialog result as true on click on confirm button,
    // then we can get dialog result from caller code

    this.result = true;
    this.close();

  }

  GetEmailBody(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml( this.emailContent );
  }

}
